/* istanbul ignore file - better tested visually */

import { classNames } from '@partful/shared/lib/classNames';
import { ComponentProps, forwardRef } from 'react';
import styles from './Surface.module.scss';

type SurfaceProps = {
  glass?: boolean;
  shadow?: 'small' | 'medium' | 'large';
  clipSize?: 'small' | 'medium' | 'large';
  clip?: 'all' | 'top' | 'top-right' | 'right' | 'bottom-right' | 'bottom' | 'bottom-left' | 'left' | 'top-left';
};

export const Surface = forwardRef<HTMLDivElement, ComponentProps<'div'> & SurfaceProps>(
  ({ glass, shadow, clip, clipSize, className, children, ...rest }, ref) => (
    <div
      className={classNames(
        styles.surface,
        glass ? styles.glass : undefined,
        shadow && styles[`shadow-${shadow}`],
        clip && [styles[`clip-${clip}`], styles[`clip-${clipSize ?? 'medium'}`]],
        className
      )}
      {...rest}
      ref={ref}
    >
      {children}
    </div>
  )
);

type SurfaceClipShadowProps = Pick<SurfaceProps, 'shadow'>;
export const SurfaceClipShadow = forwardRef<HTMLDivElement, ComponentProps<'span'> & SurfaceClipShadowProps>(
  ({ shadow, className, children, ...rest }, ref) => (
    <span
      className={classNames(styles.surfaceClipShadow, shadow && styles[`shadow-${shadow}`], className)}
      {...rest}
      ref={ref}
    >
      {children}
    </span>
  )
);
